import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269","key":"svg-0"}],["path",{"d":"M16 7v13","key":"svg-1"}],["path",{"d":"M12 20v-9","key":"svg-2"}],["path",{"d":"M8 20v-5","key":"svg-3"}]]

const IconCellSignal5 = createReactComponent('outline', 'cell-signal-5', 'CellSignal5', __iconNode);

export default IconCellSignal5;